import { Box, Button, IconButton, Typography } from '@mui/material';

import AddMedication from './addMedication';
import MedicationDetails from './MedicationDetails';
import ConfirmationModal from '../../components/shared/ConfirmationModal';

import {
  ArrowLeftIcon,
  PlusCircleIcon,
} from '../../components/shared/CustomIcons';
import MESSAGES from '../../constants/message';

import { IMedicationComponent } from './types';

const containerStyles = {
  bgcolor: 'solitude.main',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
};
const headerStyles = { paddingTop: 8, paddingX: 3, paddingBottom: 5 };
const buttonContainerStyles = {
  paddingX: 3,
  paddingBottom: 6.75,
  marginTop: 'auto',
};
const buttonStyles = { paddingY: 2.5, gap: 1 };
const backButtonStyles = { color: 'text.primary', padding: 0, marginBottom: 4 };

const MedicationComponent: React.FC<IMedicationComponent> = ({
  isAddMedicationModalOpen,
  isDeleteModalOpen,
  isPreviewModalOpen,
  selectedMedication,
  medicationList,
  setIsAddMedicationModalOpen,
  setIsDeleteModalOpen,
  setIsPreviewModalOpen,
  handleBackNavigation,
  handleAddMedication,
  handleDeleteMedication,
}) => {
  return (
    <Box sx={containerStyles}>
      <Box sx={headerStyles}>
        <IconButton
          aria-label="back"
          sx={backButtonStyles}
          onClick={handleBackNavigation}
        >
          <ArrowLeftIcon sx={{ fontSize: 40 }} />
        </IconButton>
        <Typography variant="h4">Medications list</Typography>
      </Box>

      <Box
        sx={{ gap: '1px', marginBottom: 6.75, flexGrow: 1 }}
        className="d-flex flex-column"
      >
        {medicationList}
      </Box>

      <MedicationDetails
        isPreviewModalOpen={isPreviewModalOpen}
        selectedMedication={selectedMedication}
        setIsPreviewModalOpen={setIsPreviewModalOpen}
      />

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message={MESSAGES.MEDICATION.DELETE.CONFIRMATION.MESSAGE}
        confirmButtonText={
          MESSAGES.MEDICATION.DELETE.CONFIRMATION.CONFIRM_BUTTON
        }
        cancelButtonText={MESSAGES.MEDICATION.DELETE.CONFIRMATION.CANCEL_BUTTON}
        setIsOpen={setIsDeleteModalOpen}
        onConfirm={handleDeleteMedication}
      />

      <Box sx={buttonContainerStyles}>
        <Button
          variant="contained"
          color="info"
          size="small"
          fullWidth
          sx={buttonStyles}
          onClick={handleAddMedication}
          startIcon={<PlusCircleIcon />}
        >
          {MESSAGES.MEDICATION.ADD.BUTTON}
        </Button>
      </Box>

      <AddMedication
        isModalOpen={isAddMedicationModalOpen}
        setIsModalOpen={setIsAddMedicationModalOpen}
      />
    </Box>
  );
};

export default MedicationComponent;
